import {
  formatHierarchyPath,
  hierarchyPathRows,
} from "../utils/hierarchyTopic"
import { HierarchyTopicSelection } from "../types/hierarchyTopic"

type HierarchyPathDisplayProps = {
  topic: Pick<
    HierarchyTopicSelection,
    | "name"
    | "topic"
    | "level_2_name"
    | "level_3_name"
    | "level_4_name"
  >
  levelLabels?: string[]
  /** "breadcrumb" shows "A › B › C"; "rows" shows labelled chips. */
  variant?: "breadcrumb" | "rows"
  className?: string
}

const HierarchyPathDisplay = ({
  topic,
  levelLabels,
  variant = "breadcrumb",
  className = "",
}: HierarchyPathDisplayProps) => {
  if (variant === "rows") {
    const rows = hierarchyPathRows(topic, levelLabels)
    if (!rows.length) {
      return <span className={className}>{topic.name}</span>
    }
    return (
      <div className={`flex flex-wrap gap-2 ${className}`}>
        {rows.map((row) => (
          <span
            key={row.label}
            className="inline-flex items-center gap-1 rounded border border-gray-200 bg-white px-2 py-0.5 text-xs text-gray-700"
          >
            <span className="font-medium text-gray-500">{row.label}:</span>
            <span>{row.value}</span>
          </span>
        ))}
      </div>
    )
  }

  return (
    <span className={className}>
      {formatHierarchyPath(topic, levelLabels)}
    </span>
  )
}

export default HierarchyPathDisplay
